import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { COMPANY } from '../content/seo';

/**
 * Sticky public header used on the landing page and every SEO landing sub-page.
 */
export default function PublicHeader({ onQuote }) {
  const [open, setOpen] = useState(false);

  const links = [
    { to: '/', label: 'Home' },
    { to: '/products', label: 'Products' },
    { to: '/industries/hotels', label: 'Industries' },
    { to: '/services', label: 'Services' },
    { to: '/blog', label: 'Blog' },
    { to: '/shop', label: 'Shop' },
    { to: '/#contact', label: 'Contact' },
  ];

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-neutral-200">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="public-header-logo">
          <div className="w-9 h-9 rounded-full bg-emerald-800 text-white grid place-items-center font-serif font-bold text-lg">B</div>
          <span className="font-serif font-bold text-lg text-neutral-900 hidden sm:inline">
            {COMPANY.name.split(' ').slice(0, 2).join(' ')}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-sm text-neutral-700 hover:text-emerald-700 font-medium"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a href={`tel:${COMPANY.phone}`} className="text-sm text-neutral-700 flex items-center gap-1 hover:text-emerald-700">
            <Phone className="w-3.5 h-3.5" /> {COMPANY.phoneDisplay}
          </a>
          {onQuote && (
            <Button
              onClick={onQuote}
              className="bg-emerald-700 hover:bg-emerald-800"
              data-testid="public-header-quote"
            >
              Request Quote
            </Button>
          )}
        </div>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="public-header-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-neutral-200 bg-white">
          <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-neutral-800 font-medium"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </Link>
            ))}
            {onQuote && (
              <Button
                onClick={() => { setOpen(false); onQuote(); }}
                className="bg-emerald-700 hover:bg-emerald-800 mt-2"
              >
                Request Quote
              </Button>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
